<template>
  <div>
    <b-modal
      :hide-header="false"
      :hide-footer="true"
      content-class="modal-blue"
      id="active-survey-subjects-modal"
        hide-backdrop
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      :hide-header-close="false"
     
      size="md">
      <!-- Modal content -->
      <div class="row text-white content">
        <div v-if="chosenSurvey" class="col mb-5 pb-5" style="height: 350px; overflow-y: scroll;">
          <div class="mb-4">{{ $t('surveys.title') }}</div>

        
 
                <div :class="subject.subjectID===subject.answered?'disabled':''"  class="subjects" v-for="subject in subjects" @click="openSurveyModalBySubject(subject.subjectID)">
                   {{ helpers.getLocalizedField(subject, 'subject') }}

                   <span  v-if="subject.subjectID===subject.answered"><img   src="/static/images/icons/evaluations/accept.png"   class="img-fluid mr-2 mr-sm-3 p-0 p-sm-1 ic"></span>

                </div>    
           
      
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SurveyResource from '../../api/surveyResource';
 const surveyResource = new SurveyResource();

export default {
  name: 'active-survey-subjects-modal',
 
  computed: {
    ...mapGetters({
      surveys: 'survey/surveys'
    })
  },
mounted() {
  window.addEventListener('resize', this.positionModal)
},
beforeDestroy() {
  window.removeEventListener('resize', this.positionModal)
},
  watch: {
    surveys(val) {
      if(val.length > 0) {
        this.setChosenSurvey(val[0]);
            surveyResource.subjects(val[0].surveyID)
        .then(response => {
          this.subjects = response.data.data;
        });
        
      } else {
        this.$bvModal.hide('survey-modal');
        this.chosenSurvey = null;
        this.subjects=[]
      }
    }
  },

  data() {
    return {
      chosenSurvey: null,
      subjects:[]
   
    }
  },

  methods: {
    setChosenSurvey(survey) {
      this.chosenSurvey = survey;
    },

    positionModal() {
 this.$nextTick(() => {
  const modal = document.getElementById('active-survey-subjects-modal')
  const dialog = modal.querySelector('.modal-dialog')

  const contentWidth = dialog.offsetWidth
  const contentHeight = dialog.offsetHeight
  const viewportWidth = window.innerWidth
  const viewportHeight = window.innerHeight

  /* ---------- TOP (based on width) ---------- */

  const minTop = 60
  const maxTop = viewportHeight * 0.6

  const calculatedTop = Math.max(
    minTop,
    maxTop - contentWidth * 0.25
  )

  /* ---------- LEFT (based on width + viewport) ---------- */

  // Ideal: center
  let calculatedLeft = (viewportWidth - contentWidth) / 2

  // Clamp so it never goes off-screen
  const minLeft = 16
  const maxLeft = viewportWidth - contentWidth - 16

  calculatedLeft = Math.min(
    Math.max(calculatedLeft, minLeft),
    maxLeft
  )

  /* ---------- APPLY ---------- */

  modal.style.top = `${calculatedTop}px`
  modal.style.left = `${calculatedLeft}px`
})

  },

  openSurveyModalBySubject(subjectID){

         this.$bvModal.show('survey-modal');

         this.$store.dispatch('survey/setChosenSubjectForSurvey',subjectID)

         

  }

    
  }
};
</script>
<style >
  .content {
    font-size: 1.6rem;
  }
 
.subjects{
    background-color: white;
    border-radius: 10px;
    margin-top: 10px;
    padding: 10px;
    color: #4d4d4d;
    cursor: pointer;
}
 .disabled {
  pointer-events: none;
  color: #c7b1b1 !important;
}
</style>
